"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APIConsumerCard = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
var _SVBButton = require("../../../SVBButton");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * 
 * @param title- Title for card
 * @param headerTitle - Header tag at the top for the card
 * @param description - Description for the card
 * @param buttonText - Title for the button
 * @param color - color for the card {blue|green|violet|yellow} 
 *              - supports only 4 colors as per the figma design
 * @param handleButtonPress - event on click of button
 * @returns API Consumer Card
 */
const APIConsumerCard = props => {
  var _props$title, _props$headerTitle, _props$description, _props$color, _props$buttonText;
  const title = (_props$title = props === null || props === void 0 ? void 0 : props.title) !== null && _props$title !== void 0 ? _props$title : "";
  const headerTitle = (_props$headerTitle = props === null || props === void 0 ? void 0 : props.headerTitle) !== null && _props$headerTitle !== void 0 ? _props$headerTitle : "";
  const description = (_props$description = props === null || props === void 0 ? void 0 : props.description) !== null && _props$description !== void 0 ? _props$description : "";
  const color = (_props$color = props === null || props === void 0 ? void 0 : props.color) !== null && _props$color !== void 0 ? _props$color : "";
  const buttonText = (_props$buttonText = props === null || props === void 0 ? void 0 : props.buttonText) !== null && _props$buttonText !== void 0 ? _props$buttonText : "";
  const handleButtonPress = props === null || props === void 0 ? void 0 : props.handleButtonPress;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col p-4 api-consumer-card-container acc-bt-".concat(color)
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "fw-bold d-inline-flex px-4 py-1 font-family-roboto paragraph small acc-tag-".concat(color)
  }, headerTitle), /*#__PURE__*/_react.default.createElement("h2", {
    className: "heading-medium-large pt-3"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "api-consumer-card-highlighter mt-4 acc-".concat(color)
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "paragraph pt-4 mr-3 font-family-roboto"
  }, description), /*#__PURE__*/_react.default.createElement(_SVBButton.SVBButton, {
    rightIconExtraClasses: "api-consumer-card-button-icon",
    extraClasses: "acc-".concat(color, " border-0 font-family-roboto"),
    text: buttonText,
    size: "large",
    style: "primary",
    state: "default",
    type: "text",
    icon: "down",
    iconSide: "right",
    onClick: handleButtonPress
  }));
};
exports.APIConsumerCard = APIConsumerCard;